import { useContext, useMemo } from 'react';
import { U as UIDContext } from './UIDContext-DaboSTJ1.js';

function useUID(suffix) {
  const prefixer = useContext(UIDContext);
  return useMemo(() => prefixer(suffix), [suffix, prefixer]);
}

export { useUID as u };
//# sourceMappingURL=useUID-D26A8cqB.js.map
